import React from "react";
import OnePortfolio from "@/components/dashboard/portfolio/onePortfolio";
import ListingsHead from "@/components/property/listingsHead";
import { makeStyles } from "tss-react/mui";
import { AppSize, pxToRem } from "@/util";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getSinglePortfolioApi } from "@/util/api/portfolio";
import ScrollDialog from "../global/dialog";
import Loader from "@/app/loading";

type Props = {
  handleClose: () => void;
  id: string;
};

export default function PortfolioPopup({ handleClose, id }: Props) {
  const { classes } = styles();
  const [open, setOpen] = React.useState(true);

  const { data, isPending, isError, error } = useQuery({
    queryKey: ["listing", id],
    queryFn: () => getSinglePortfolioApi(id),
    enabled: !!id,
  });

  const listing = data?.payload;
  const property = listing?.property;

  if (isError) {
    console.error("Error fetching listing:", error);
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.head}>
        {/* <ListingsHead
          handleBack={handleClose}
          name={property?.name || "Unknown Property"}
          location={property?.address || ""}
          isShare={false}
          isAmount={false}
        /> */}
      </Box>

      {isPending ? (
        <Loader imageType="bar" />
      ) : isError ? (
        <Box>Error loading property</Box>
      ) : property ? (
        <ScrollDialog open={open} onClose={() => setOpen(false)}>
          <Box className={classes.head}>
            <ListingsHead
              handleBack={handleClose}
              name={property?.name || "Unknown Property"}
              location={property?.address || ""}
              isShare={false}
              isAmount={false}
            />
          </Box>
          <OnePortfolio data={property} />
        </ScrollDialog>
      ) : (
        <>
          <Box>No property found</Box>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: "12px" }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </>
      )}
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(4),
  },

  head: {
    padding: `${pxToRem(20)} ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(15)} ${pxToRem(10)}`,
    },
  },
}));
